import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import IncompleteProcessReportCriteria from './IncompleteProcessReportCriteria';


@NeoReport("IncompleteProcess",  { category: MaintenanceReportCategories.SystemInformationReports})
export default class IncompleteProcessReport extends Report<IncompleteProcessReportCriteria>{

    constructor() {
        super(IncompleteProcessReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}